import { render } from "./ChargebeeUpsellMarketing.vue?vue&type=template&id=4b155c76&scoped=true"
import script from "./ChargebeeUpsellMarketing.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketing.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketing.vue?vue&type=style&index=0&id=4b155c76&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b155c76"]])

export default __exports__